"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = isObject;
function isObject(value) {
  return value instanceof Object && !Array.isArray(value);
}


//////////////////
// WEBPACK FOOTER
// ./~/inline-style-prefixer/lib/utils/isObject.js
// module id = 123
// module chunks = 35783957827783 231608221292675